import React, { useEffect, useState } from "react";
import {
  Avatar,
  Card,
  Pagination,
  Popconfirm,
  Table,
  Typography,
  message,
} from "antd";
import axiosInstance from "../../../../api/Axios";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteTwoTone,
  UserOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { capitalizeWords } from "../../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import AddTrainersVirtual from "../../../../components/AdminComponents/Modals/AddTrainersVirtual";
const { Title } = Typography;
const CourseTrainers = ({ data1, loading, LoadUser, ImpersonateAccess }) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();

  const [messageApi, contextHolder] = message.useMessage();
  const [data, setData] = useState([]);
  const [loading2, setLoading2] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const [showAdd, setShowAdd] = useState(false);
  const [filterData, setFilterData] = useState({
    pageSize: 10,
    currentPage: 1,
    url: `/user/?organization=${userInfo.data.organization.id}&course_id=${id}&organization_user_archived=False`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, search, filter_url } = filterData;
  console.log(url);
  const LoadUser2 = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `&page_num=${currentPage}&items=${pageSize}&search=${search}${filter_url}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page_num=${currentPage}&items=${pageSize}${filter_url}`;
    }
    if (!doNothing) {
      setLoading2(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res?.data?.data?.User_data || []);
        setItemsLength(res?.data?.data?.paginator?.count || 0);
        setLoading2(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };

  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.6rem",
              height: "1.6rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.6rem",
              height: "1.6rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Trainer has been removed successfully.",
      duration: 5,
    });
    LoadUser2();
    LoadUser();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Failed to remove trainer.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDelete = async (record) => {
    //console.log("coming here", record.id);
    try {
      await axiosInstance.delete(
        `/coursetrainer/?course_id=${id}&user_id=${record.id}`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      //console.log(res);
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const columns = [
    {
      title: "Trainer Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.avatar || null}
            icon={!record?.avatar && <UserOutlined />}
            alt={record?.name}
            size="small"
          />
          <span>
            {record?.first_name} {record?.last_name}
          </span>
        </div>
      ),
    },
    {
      title: "Phone No.",
      dataIndex: "phone_number",
      key: "phone_number  ",
      width: 150,
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 220,
    },
    {
      title: capitalizeWords("Department"),
      dataIndex: "department",
      key: "department",
      width: 150, // set width to 150px
      render: (text, record) => (
        <span>{record?.organization?.department?.dep_name || ""}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "state",
      key: "state",
      align: "center",

      render: renderStatus,
      width: 100,
    },

    ...(ImpersonateAccess
      ? [
          {
            title: "Actions",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 100,
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Popconfirm
                  title={"Remove Trainer"}
                  description="This account will be un-assigned from the course"
                  onConfirm={() => {
                    handleDelete(record);
                  }}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                >
                  <DeleteTwoTone
                    style={{
                      cursor: "pointer",
                      fontSize: "1.6rem",
                      marginLeft: "0.7rem",
                    }}
                    title="Archive"
                    twoToneColor="#eb2f96"
                  />
                </Popconfirm>
              </div>
            ),
          },
        ]
      : []),
  ];

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    if (id) {
      LoadUser2();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, id]);
  const handleFilterChange = () => {
    setShowAdd((prev) => !prev);
  };
  const CreateSuccessfull = (text) => {
    LoadUser2();
    LoadUser();
    messageApi.open({
      type: "success",
      content: text || "Trainer added successfully",
      duration: 5,
    });
  };

  const CreateFailed = (text) => {
    messageApi.open({
      type: "error",
      content: text || "Failed to add trainer",
      duration: 5,
    });
  };
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Trainers Summary
      </Title>
      <CommonTopDetails
        title={`Course Trainers`}
        titleSuffix={`${itemsLength || 0} trainer(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={ImpersonateAccess}
        addButtonProps={{
          modalType: "PopUP",
          modalProps: handleFilterChange,
        }}
        topSizeAdd="5px"
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
      />

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading2}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 300,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <AddTrainersVirtual
        visible={showAdd}
        onCancel={handleFilterChange}
        org_id={userInfo.data.organization.id}
        id={id}
        CreateSuccessfull={CreateSuccessfull}
        CreateFailed={CreateFailed}
      />
    </Card>
  );
};

export default CourseTrainers;
